<template>
  <v-card outlined tile>
    <v-card-text>
      <v-container fluid class="ma-0 pa-0">
        <v-card outlined>
          <v-card-text class="ma-2 pa-0">
            <v-data-table
              height="70vh"
              fixed-header
              dense
              :headers="headers"
              :items="displayDevices"
              item-key="id"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              @page-count="pageCount = $event"
              hide-default-footer
              class="v-data-table-outlined"
              :loading="_loading"
              :custom-sort="customSort"
            >
              <template v-slot:top>
                <v-btn @click="searchOpen = !searchOpen" color="primary"
                  >検索
                  <v-icon v-if="searchOpen" class="ml-10">mdi-chevron-up</v-icon>
                  <v-icon v-else class="ml-10">mdi-chevron-down</v-icon>
                </v-btn>
                <v-card v-if="searchOpen" flat tile class="mt-3 pa-3 v-card-border-bottom">
                  <v-form v-model="valid" ref="form" @submit.prevent>
                    <v-row class="d-flex align-center">
                      <v-col cols="2"
                        ><v-text-field
                          v-model="searchWord.pastDayFrom"
                          :label="$t(`maintenancePastDayFrom`)"
                          hide-details
                          outlined
                          dense
                        ></v-text-field
                      ></v-col>
                      <v-col cols="1">～</v-col>
                      <v-col cols="2"
                        ><v-text-field
                          v-model="searchWord.pastDayTo"
                          :label="$t(`maintenancePastDayTo`)"
                          hide-details
                          outlined
                          dense
                        ></v-text-field
                      ></v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-card-actions>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="reset"
                                color="primary"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                class="mr-2"
                                depressed
                              >
                                <v-icon>mdi-close</v-icon></v-btn
                              >
                            </template>
                            <span>{{ $t('deleteSearchConditions') }}</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="searchClicked" color="primary" dark v-bind="attrs" v-on="on" depressed>
                                <v-icon>mdi-magnify </v-icon></v-btn
                              >
                            </template>
                            <span>{{ $t('search') }}</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card>
                <v-row class="px-2">
                  <v-col cols="6" sm="6" md="6" ls="6" xl="6">
                    {{ $t(`display`) }}
                    <div class="d-inline-block">
                      <v-select
                        :value="selectedItemsPerPage"
                        :items="[
                          { text: '10', value: 10 },
                          { text: '20', value: 20 },
                          { text: $t(`all`), value: -1 },
                        ]"
                        item-text="text"
                        item-value="value"
                        @change="itemsPerPage = parseInt($event, 10)"
                      />
                    </div>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" ls="6" xl="6" v-if="pageCount > 1">
                    <div class="float-right">
                      <v-btn
                        @click="changePage(1)"
                        :color="page !== 1 ? 'primary' : ''"
                        :dark="page !== 1"
                        small
                        :disabled="page === 1"
                        class="mr-3"
                        ><v-icon>mdi-page-first</v-icon>1</v-btn
                      >
                      <v-btn
                        @click="prevPage"
                        :color="page !== 1 ? 'primary' : ''"
                        :dark="page !== 1"
                        small
                        :disabled="page === 1"
                        class="mr-3"
                        ><v-icon>mdi-chevron-left</v-icon></v-btn
                      >
                      {{ page }}
                      <v-btn
                        @click="nextPage"
                        :color="page !== pageCount ? 'primary' : ''"
                        :dark="page !== pageCount"
                        small
                        :disabled="page === pageCount"
                        class="ml-3"
                        ><v-icon>mdi-chevron-right</v-icon></v-btn
                      >
                      <v-btn
                        @click="changePage(pageCount)"
                        :color="page !== pageCount ? 'primary' : ''"
                        :dark="page !== pageCount"
                        small
                        :disabled="page === pageCount"
                        class="ml-3"
                        >{{ pageCount }}<v-icon>mdi-home</v-icon></v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.device_name_locale`]="{ item }">
                <router-link
                  target="_blank"
                  :to="{ name: 'CompressorInfo', params: { model_id: item.model_id, serial_no: item.serial_no } }"
                >
                  <span class="text-subtitle-1">{{ item[`device_name_locale${localeId}`] }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.maintenanceIcon`]="{ item }">
                <span class="text-subtitle-1">
                  <v-icon
                    v-if="['danger', 'warning', 'notice'].includes(item.maintenanceIcon)"
                    class="material-symbols-outlined"
                    large
                    v-text="maintenanceNotificationIcon(item)"
                    :color="maintenanceNotificationColor(item)"
                  >
                  </v-icon
                ></span>
              </template>
              <template v-slot:[`item.maintenanceAlarm`]="{ item }">
                <span class="text-subtitle-1">
                  {{ item.maintenanceAlarm?.format('YYYY/MM/DD') }}
                </span>
              </template>
              <template v-slot:[`item.maintenancePastDay`]="{ item }">
                <span class="text-subtitle-1">{{ item.maintenancePastDay | numberFormat }}</span>
              </template>
              <template v-slot:[`item.maintenancePastTime`]="{ item }">
                <span class="text-subtitle-1">{{ item.maintenancePastTime | numberFormat }}</span>
              </template>
              <template v-slot:[`item.device_group_name_locale`]="{ item }">
                <router-link
                  target="_blank"
                  :to="{ name: 'HomeConsumer', params: { device_group_id: item.device_group_id } }"
                >
                  {{ item[`device_group_name_locale${localeId}`] }}
                </router-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    name: 'Table',
    components: {},
    mixins: [],
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: -1,
      selectedItemsPerPage: undefined, // selectの選択保持用
      items: [],
      displayDevices: [],
      searchOpen: false,
      valid: true,
      searchWord: {
        pastDayFrom: undefined,
        pastDayTo: undefined,
      },
      internalSearchWord: {
        pastDayFrom: undefined,
        pastDayTo: undefined,
      },
    }),
    props: {
      value: {
        type: [String],
        default: () => '',
      },
      devices: {
        type: [Array],
        default: () => [],
      },
      loading: {
        type: [Boolean],
        default: () => false,
      },
    },
    filters: {
      numberFormat: (value) => {
        if (isNaN(value) || value === undefined) {
          return '';
        }
        let formatter = new Intl.NumberFormat('ja-JP');
        return formatter.format(value);
      },
    },
    watch: {
      async _loading(newValue) {
        if (newValue) {
          this.displayDevices = [];
        } else {
          if (this._devices) {
            console.log('サーチ');
            try {
              await this.search();
            } finally {
              console.info('検索完了');
            }
          }
        }
      },
    },
    computed: {
      // this.$props.devicesとかぶるため変数名を変更
      _devices() {
        return this.$props.devices;
      },
      _loading() {
        return this.$props.loading;
      },
      headers() {
        return [
          {
            text: this.$t('serialNo'),
            align: 'start',
            value: 'device_name_locale',
            filterable: true,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('model'),
            align: 'start',
            value: 'optional_info_1',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('customerName'),
            align: 'start',
            value: 'device_group_name_locale',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('maintenanceIcon'),
            align: 'start',
            value: 'maintenanceIcon',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('maintenanceAlarm'),
            align: 'start',
            value: 'maintenanceAlarm',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('maintenancePastDay'),
            align: 'end',
            value: 'maintenancePastDay',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
            sortable: true,
          },
          {
            text: this.$t('maintenancePastTime'),
            align: 'end',
            value: 'maintenancePastTime',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
        ];
      },
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
      // メンテナンス通知のアイコンを返す
      maintenanceNotificationIcon() {
        return (value) => {
          const icons = {
            danger: 'clock_loader_90',
            warning: 'clock_loader_60',
            notice: 'clock_loader_10',
          };
          return icons[value.maintenanceIcon] || '';
        };
      },
      // メンテナンス通知の色を返す
      maintenanceNotificationColor() {
        return (value) => {
          const colors = {
            danger: '#FF0000', // 赤
            warning: '#FFA500', // オレンジ
            notice: '#00FF26', // 緑
          };
          return colors[value.maintenanceIcon] || '';
        };
      },
    },
    async created() {
      this.selectedItemsPerPage = { text: this.$t('all'), value: -1 };

      if (this._devices) {
        await this.search();
      }
    },
    methods: {
      customSort(items, sortBys, sortDescs) {
        if (sortBys.length === 0 || sortDescs.length === 0) {
          return items;
        }
        const sortBy = sortBys[0];
        const sortDesc = sortDescs[0];
        if (sortBy) {
          if (sortBy === 'maintenanceIcon') {
            const order = {
              danger: 1,
              warning: 2,
              notice: 3,
            };
            return items.sort((a, b) => {
              const itemA = order[a?.maintenanceIcon] ?? Object.keys(order).length + 1;
              const itemB = order[b?.maintenanceIcon] ?? Object.keys(order).length + 1;
              return (itemA < itemB ? -1 : itemA > itemB ? 1 : 0) * (sortDesc ? -1 : 1);
            });
          }
          return items.sort((a, b) => {
            const itemA = a[sortBy] ?? 0;
            const itemB = b[sortBy] ?? 0;
            return (itemA < itemB ? -1 : itemA > itemB ? 1 : 0) * (sortDesc ? -1 : 1);
          });
        }
        return items;
      },
      changePage(value) {
        // ページング処理、先頭ページ、最終ページへのジャンプ用
        this.page = value;
      },
      prevPage() {
        if (this.page !== 1) {
          this.page--;
        }
      },
      nextPage() {
        if (this.page !== this.pageCount) {
          this.page++;
        }
      },
      async reset() {
        this.$refs.form.reset(); //internalSearchWordの各項目はnullが入る
        this.internalSearchWord = this.searchWord;
        await this.search();
      },
      async searchClicked() {
        console.log('サーチ');
        this.$store.commit('loading/start_loading');
        try {
          // // INPUT項目の値を直接参照するとcustom-filterの監視対象に入ってしまう(検索ボタンを押さずに絞り込みされてしまう)ため別オブジェクトに格納
          this.internalSearchWord = this.searchWord;
          await this.search();
        } finally {
          console.info('検索完了');
          this.$store.commit('loading/end_loading');
        }
      },
      async search() {
        this.displayDevices = this.devices?.filter((el) => {
          let result = true;

          if (this.internalSearchWord.pastDayFrom != null) {
            result = result && Number(this.internalSearchWord.pastDayFrom) < el.maintenancePastDay;
          }
          if (this.internalSearchWord.pastDayTo != null) {
            result = result && el.maintenancePastDay < Number(this.internalSearchWord.pastDayTo);
          }

          return result;
        });
      },
    },
  };
</script>
<style scoped></style>
